import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
import {
  convertDateStringToDateTimezone_7Dayjs,
  convertIosStringToDateDayjs,
  convertIosStringToDateObj,
} from "helper/common";
import { formatPhoneNumber } from "helper/format-phone";
import moment from "moment";
import React from "react";
import { Row } from "antd";
const {
  INPUT,
  SELECT,
  DATE,
  COMBO_BOX,
  TEXT_AREA,
  DATE_DAY_INPUT,
  SELECT_MULTI,
} = FIELD_TYPE;

const cssProps = {
  css: { xl: 12, md: 24 },
  labelCol: { xl: 8, md: 6 },
  wrapperCol: { xl: 16, md: 18 },
};
export const mucDoHL = [
  { value: 5, label: "Rất hài lòng" },
  { value: 4, label: "Hài lòng" },
  { value: 3, label: "Bình thường" },
  { value: 2, label: "Không hài lòng" },
  { value: 1, label: "Rất không hài lòng" },
];

const mdSanLong = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

const professions = [
  { label: "Lễ tân", value: 1 },
  { label: "Bác sỹ", value: 2 },
  { label: "Điều dưỡng", value: 3 },
  { label: "Tư vấn", value: 4 },
  { label: "Kính", value: 5 },
  { label: "Xét nghiệm", value: 6 },
  { label: "Thuốc", value: 7 },
  { label: "Chăm sóc khách hàng", value: 8 },
  { label: "Nội trú", value: 9 },
];
const optionsVd = [
  { label: "Chờ đợi lâu", value: 1 },
  { label: "Thời gian PT lâu", value: 2 },
  { label: "Đau", value: 3 },
  { label: "Cộm", value: 4 },
  { label: "Chảy nước mắt", value: 5 },
  { label: "Chói, lóa", value: 6 },
  { label: "Nhìn hình đôi", value: 7 },
  { label: "Ruồi bay", value: 8 },
  { label: "Đỏ mắt", value: 10 },
  { label: "Khác", value: 9 },
];

const fields = () => {
  const fields: DataFormField[] = [
    {
      type: DATE_DAY_INPUT,
      label: "Ngày hẹn PT",
      name: "ngayHenPT",
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
      ...cssProps,
      rules: [{ required: true, message: "Chưa nhập ngày tái khám" }],
      disableDate: false,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "dienThoai",
      ...cssProps,
      rules: [{ message: "Chưa nhập số điện thoại", required: true }],
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái CSKH",
      name: "trangThaiCSKH",
      ...cssProps,
      options: JSON.parse(localStorage.getItem("TTCSKH")),
    },
    {
      type: INPUT,
      label: "Nhân viên CSKH",
      name: "nhanVienCSKH",
      ...cssProps,
    },
    {
      type: COMBO_BOX,
      label: "Mức độ hài lòng",
      name: "mucDoHaiLong",
      // css: { xl: 24, md: 24 },
      // labelCol: { xl: 4, md: 6 },
      // wrapperCol: { xl: 20, md: 20 },
      ...cssProps,
      options: mucDoHL,
    },
    {
      type: TEXT_AREA,
      label: "Nội dung phản hồi",
      name: "noiDungPhanHoi",
      ...cssProps,
    },
    {
      type: SELECT,
      label: "BP cần cải thiện",
      name: "boPhanCaiTien",
      options: professions,
      ...cssProps,
      mode: "tags",
    },
    {
      type: SELECT,
      label: "Mức độ sẵn lòng giới thiệu",
      name: "mucDoSanLong",
      options: mdSanLong,
      ...cssProps,
    },
    {
      type: SELECT,
      label: "Các vấn đề gặp phải",
      name: "cacVanDe",
      options: optionsVd,
      ...cssProps,
      mode: "tags",
    },
  ];
  return fields;
};

const allColumnsLSU: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    align: "center",
    width: 40,
    fixed: "left",
  },
  {
    title: "Ngày gọi",
    dataIndex: "createdDate",
    show: true,
    align: "center",
    width: 150,
    render: (t) => convertDateStringToDateTimezone_7Dayjs(t),
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    width: 100,
    align: "right",
    render: (t) => formatPhoneNumber(t),
  },
  {
    title: "Nhân viên CSKH",
    dataIndex: "nhanVienCSKH",
    show: true,
    align: "left",
    width: 100,
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThaiCSKH",
    show: true,
    width: 100,
    align: "left",
    render: (text) => {
      return (
        JSON.parse(localStorage.getItem("TTCSKH")).find(
          (option) => option.value === text
        )?.label || ""
      );
    },
  },
  {
    title: "Mức độ hài lòng",
    dataIndex: "mucDoHaiLong",
    show: true,
    width: 150,
    align: "left",
    render: (text) => {
      return mucDoHL.find((option) => option.value === text)?.label || "";
    },
  },
  {
    title: "BP cần cải tiến",
    dataIndex: "boPhanCaiTien",
    show: true,
    width: 150,
    align: "left",
    render: (text) => {
      return (
        <div>
          {text &&
            text.map((value) => {
              const profession = professions.find(
                (prof) => prof.value === value
              )?.label;
              return <div key={value}>{profession ? profession : ""}</div>;
            })}
        </div>
      );
    },
  },
  {
    title: "Mức độ sẵn lòng giới thiệu",
    dataIndex: "mucDoSanLong",
    show: true,
    width: 150,
    align: "left",
  },
  {
    title: "Các vấn đề gặp phải",
    dataIndex: "cacVanDe",
    show: true,
    width: 150,
    align: "left",
    render: (v) =>
      v
        ? v.map((e) => {
            {
              const res = optionsVd.find((prof) => prof.value === e)?.label;
              return <div key={e}>{res ? res : ""}</div>;
            }
          })
        : "",
  },

  {
    title: "Nội dung",
    dataIndex: "noiDungPhanHoi",
    show: true,
    width: 350,
    align: "left",
  },
  {
    key: "action",
    dataIndex: "action",
    title: "Thao tác",
    width: 70,
    fixed: "right",
  },
];

export { allColumnsLSU, fields };
